// init
// import 'flowbite';
import AOS from 'aos';

import shrink from './init/shrink.js';
// import menu from './init/menu.js';
import smooth, { lenisInstance } from './init/smoothScroll.js';

// components
import splideFullscreen from './components/splideFullscreen.js';
import splideCarousel from './components/splideCarousel.js';
import lightgalleryGallery from './components/lightgalleryGallery.js';

// modules
import moduleHotspots from './modules/module-hotspots.js';
import moduleMap from './modules/module-map.js';


// Helper function to conditionally initialize modules
const initIfExists = (selector, callback) => {
    if (document.getElementsByClassName(selector).length > 0) {
        callback();
    }
};

///////////////////////////////////////////////////////////////////////////////////


// customCursor();

// // before loaded
document.addEventListener('DOMContentLoaded', beforeLoad);

// load
window.addEventListener('load', () => {

    // 	// const loader = document.querySelector('.loading');

    // 	// setTimeout(() => {
    // 	// 	loader.classList.add('hidden');
    // 	// 	loader.addEventListener('transitionend', () => {
    // 	// 		loader.style.display = 'none';
    // 	// 	});
    // 	// }, 500);

    start();

});

// // Window On Resize
// window.addEventListener('resize', onResize);

// ///////////////////////////////////////////////////////////////////////////////////

function beforeLoad() {

    smooth();
    shrink();
    initIfExists("splide--fullscreen", splideFullscreen);
    initIfExists("map", moduleMap);
    initIfExists("splide--carousel", splideCarousel);
    initIfExists("lightgallery__gallery", lightgalleryGallery);
    initIfExists("hotspots", moduleHotspots);
}

function start() {

    AOS.init();
    scrollLinks();
}

// function onResize() {}

function scrollLinks() {
    const navItems = document.querySelectorAll('.menu-item a');
    navItems.forEach(item => {
        item.addEventListener('click', (e) => {
            const targetId = item.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                e.preventDefault();

                // Use Lenis scrollTo for smooth scrolling
                if (lenisInstance) {
                    lenisInstance.scrollTo(targetElement, {
                        offset: 0,
                        duration: 1.2,
                        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
                    });
                } else {
                    // Fallback to native scroll if Lenis is not available
                    targetElement.scrollIntoView({ behavior: 'smooth', block: "center", inline: "nearest" });
                }
            }
        });
    });
}